/**
 * Copyright © 2026 Adnuntius AS.
 */

type ChartType = {
  id: string;
  keyed?: string;
  eventHook: any;
};

type ChartInfo = {
  dataTypes: Record<string, ChartType>;
  statsMethod: string;
  csvTitle: string;
};

type RelatedChart = Record<string, ChartInfo>;

export const RELATED_CHART_DATA: RelatedChart = {
  TRAFFIC: {
    dataTypes: {
      deviceType: {
        id: 'deviceType',
        keyed: 'targeting.device',
        eventHook: {}
      },
      osType: {
        id: 'osType',
        keyed: 'targeting.device',
        eventHook: {}
      },
      mobileBrand: {
        id: 'mobileBrand',
        keyed: 'targeting.device',
        eventHook: {}
      },
      app: {
        id: 'app',
        keyed: 'targeting.device',
        eventHook: {}
      }
    },
    statsMethod: 'getTraffic',
    csvTitle: 'Traffic'
  },
  LOCATION: {
    dataTypes: {
      country: {
        id: 'country',
        eventHook: {}
      }
    },
    statsMethod: 'getLocation',
    csvTitle: 'Location'
  },
  DOMAIN: {
    dataTypes: {
      domain: {
        id: 'domain',
        eventHook: {}
      }
    },
    statsMethod: 'getDomain',
    csvTitle: 'Domain'
  }
};
